import { render, staticRenderFns } from "./DashboardWidgetWrap.vue?vue&type=template&id=42d479e0&scoped=true"
import script from "./DashboardWidgetWrap.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetWrap.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetWrap.vue?vue&type=style&index=0&id=42d479e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d479e0",
  null
  
)

export default component.exports